<section class="contract-security astral-stack-l">
  <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
    <app-money-box [control]="form.controls['depositAmount']"></app-money-box>
    <astral-input
      class="astral-grid-desktop-span-3"
      [control]="form.controls['depositComment']"
    ></astral-input>
  </astral-layout-group>

  <div class="contract-security__guarantors astral-stack-l">
    @for (ownerForm of $any($safeNavigationMigration(securities?.controls)); track ownerForm; let i = $index) {
      <div class="contract-security__guarantor-card astral-form-stack">
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [alignItems]="'center'">
          <app-autocomplete-remote
            [service]="tenantService"
            [control]="ownerForm.controls['contactId']"
            (itemSelectedNewId)="onTenantSelected($event, ownerForm)"
          ></app-autocomplete-remote>

          @if (dataContext.category == 0) {
            <astral-select
              [control]="ownerForm.controls['responsibility']"
              [itemsSource]="responsibilitySelection"
            ></astral-select>
          }

          <div class="contract-security__delete-action astral-form-adjacent-action">
            <astral-button
              variant="secondary"
              type="button"
              icon="trash"
              labelKey="DELETE_BTN"
              (click)="delete(i)"
            ></astral-button>
          </div>
        </astral-layout-group>

        @if (ownerForm.controls['responsibility']?.value == CreditorResponsibility.Limited && dataContext.category == 0) {
          <astral-layout-group [columns]="1" [tabletColumns]="1" [mobileColumns]="1">
            <astral-textarea [control]="ownerForm.controls['comment']"></astral-textarea>
          </astral-layout-group>
        }
      </div>
    }

    <div class="contract-security__add-action">
      <astral-button
        variant="primary"
        type="button"
        icon="plus"
        labelKey="LEASE_AGREEMENT.ADD_GUARANTOR"
        (click)="addGuarantor()"
      ></astral-button>
    </div>
  </div>
</section>
